<template>
    <div style="display: flex;flex-direction: column;  overflow: hidden;height: calc(100vh - 85px) ;background-color: #ffffff;">
        <el-form ref="searchForm" :model="searchForm" size="mini" label-width="120px"  class="demo-form-inline searchForm"> 
            <el-row>
                <el-col :span="6">
                    <el-form-item label="物项名称" prop="goodsName">
                        <el-input  clearable v-model="searchForm.goodsName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="HS编码" prop="hsCode">
                        <el-input clearable v-model="searchForm.hsCode" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="管控原因" prop="reason">
                        <el-input clearable v-model="searchForm.reason"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="监管代码" prop="controlCode">
                        <el-input clearable v-model="searchForm.controlCode"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="物项描述" prop="text">
                        <el-input clearable v-model="searchForm.text"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                        <el-button  style="margin-left: 15px;" type="primary" size="mini" @click="getData">搜索</el-button>
                        <el-button  style="margin-left: 15px;" type="success" size="mini" @click="addDualUseItem">新增</el-button>
                        <el-button  style="margin-left: 15px;" type="danger" size="mini" @click="delDualUseItem">删除</el-button>
                </el-col>
            </el-row>
        </el-form>
        <div style="flex:1;overflow: hidden" >
            <el-table :data="dualUseItemTable" style="width: 100%" :header-cell-style="{'text-align':'center'}" size="mini" height="100%"
            @selection-change="handleSelectionChange" border>
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column type="index" width="50"> </el-table-column>
                <!-- <el-table-column property="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 0" type="success">在用</el-tag>
                        <el-tag v-else type="danger">禁用</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column property="goodsName" label="物项名称" width="140" align="center"></el-table-column>
                <el-table-column property="hsCode" label="HS编码" width="100" align="center"></el-table-column>
                <el-table-column property="controlCode" label="监管代码" width="100" align="center" ></el-table-column>
                <el-table-column property="reason" label="管控原因" align="left" ></el-table-column>
                <el-table-column property="text" label="物项描述" align="left" ></el-table-column>
                <el-table-column property="createMan" label="创建人" width="80" align="center"></el-table-column>
                <el-table-column property="createTime" label="创建时间" width="140" align="center"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button @click="exitDualUseItem(scope.row)" type="primary" size="mini">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-sizes="[50, 100, 200, 500]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
    </el-pagination>
    <!-- 新增更新两用物项 -->
     <el-dialog title="新增/变量两用物项" :visible.sync="addDualUseItemVisible" width="75%" @close="addDualUseItemClose" v-dialogDrag
     :close-on-click-modal="false">
        <el-form ref="addDualUseItem" :model="addDualUseItemForm" label-width="120px"  class="demo-form-inline" size="mini"
        :rules="addDualUseItemRules" > 
            <el-form-item label="物项名称" prop="goodsName">
                <el-input  clearable v-model="addDualUseItemForm.goodsName"></el-input>
            </el-form-item>
            <el-form-item label="HS编码" prop="hsCode">
                <el-input  clearable v-model="addDualUseItemForm.hsCode"></el-input>
            </el-form-item>
            <el-form-item label="管控原因" prop="reason">
                <el-input  clearable v-model="addDualUseItemForm.reason"></el-input>
            </el-form-item>
            <el-form-item label="监管代码" prop="controlCode">
                <el-input  clearable v-model="addDualUseItemForm.controlCode"></el-input>
            </el-form-item>
            <el-form-item label=" " prop="">
                <el-button size="mini" type="primary" @click="getRuleText">规则提取</el-button>
            </el-form-item>
            <el-form-item label="物项描述" prop="text">
                <el-input   type="textarea" :rows="2" v-model="addDualUseItemForm.text"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="mini" @click="addDualUseItemClose">取 消</el-button>
            <el-button size="mini" type="primary" @click="saveAddDualUseItem">确 定</el-button>
        </span>
     </el-dialog>
    </div>
</template>
<script> 
import clean from 'lodash-clean';
export default {
    name: 'dualUseItem',
    data() {
        return {
            searchForm:{
                goodsName:"",
                hsCode:"",
                reason:"", // 管控原因
                controlCode:"", // 监管代码
                text:"", // 物项描述
            },
            dualUseItemTable:[],
            addDualUseItemForm:{
                goodsName:"",
                hsCode:"",
                reason:"", // 管控原因
                controlCode:"", // 监管代码
                text:"", // 物项描述
            },
            // ruleText:'', // 物项描述
            addDualUseItemVisible:false, // 新增弹窗
            multipleSelection:[], // 多选数组
            // 分页信息
            pagination:{
                totalPages: 0, // 总页数
                total: 0, // 总条数
                currentPage: 1, // 当前页数
                pageSize: 50, // 每页显示多少条数据
            },
            addDualUseItemRules:{ // 新增弹窗表单验证
                goodsName:[
                    { required: true, message: '请输入物项名称', trigger: 'blur' },
                ],
                // hsCode:[
                //     { required: true, message: '请输入HS编码', trigger: 'blur' },
                // ],
                reason:[
                    { required: true, message: '请输入管控原因', trigger: 'blur' },
                ],
                controlCode:[
                    { required: true, message: '请输入监管代码', trigger: 'blur' },
                ],
                text:[ 
                    { required: true, message: '请输入规则描述', trigger: 'blur' },
                ]
            },
        }
    },
    computed: {
        
    },
    mounted() {
        this.getData()
    },
    created() {

    },
    methods: {
        // 每页条数修改
        handleSizeChange(val){
            this.pagination.pageSize = val
            this.getData()
        },
        // // 当前页码修改
        handleCurrentChange(val){
            this.pagination.currentPage = val
            this.getData()
        },
        // 从第一页开始查询
        resetPage(){
            this.pagination.currentPage = 1
            this.getData()
        },
        // 获取规则数据
        getData(){
            const params = {...this.searchForm}
            this.$api.getAiDualUse(this.pagination.currentPage,this.pagination.pageSize, params).then(res =>{
                this.dualUseItemTable = res.records
                this.pagination.total = res.total
                this.pagination.currentPage = res.current
                this.pagination.pageSize = res.size
            })
        },
        // 新增两用物项规则
        addDualUseItem(){
            this.addDualUseItemVisible = true
        },
        addDualUseItemClose(){
            this.addDualUseItemVisible = false
            this.addDualUseItemForm = {
                goodsName:"",
                hsCode:"",
                reason:"", // 管控原因
                controlCode:"", // 监管代码
                text:"", // 物项描述
            }
        },  
        async saveAddDualUseItem() {
            // 是否确认
            this.$confirm('是否确认新增两用物项规则?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$refs.addDualUseItem.validate(async valid => {
                    if (!valid) return;
                    // 将拼接文本赋值到form
                    this.$api.AiPushToDashvector(this.addDualUseItemForm).then(res =>{
                        this.resetPage()
                        this.addDualUseItemClose()
                    })
                })
            }).catch(() => {
            });
            
        },
        exitDualUseItem(row){
            this.addDualUseItemForm = {...row}
            this.addDualUseItemVisible = true
        },
        // 获取规则文本
        getRuleText() {
            const form = this.addDualUseItemForm;
            const arr = [
                form.goodsName || '',
                form.hsCode || '',
                form.reason || '',
            ];
            // 使用;连接
            this.addDualUseItemForm.text =  arr.join(';');
        },
        // 多选
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 删除规则
        delDualUseItem(){
            this.$confirm('是否确认删除该条数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const ids = this.multipleSelection.map(item => item.id)
                this.$api.AiDeleteDualUse(ids).then(res =>{
                    this.resetPage()
                })
            })
        },
    },

}
</script>
<style scoped lang="less">
.width_100{
    width: 100% !important;
}

// 表头样式
.searchForm {
    margin: 0px 10px !important;
}

.searchForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 5px !important;
    width:100% !important;
}
/* 没有 scoped 直接写 */
.el-table,
.el-table__header tr,
.el-table__header th,
.el-table__body tr,
.el-table__body td {
  border-color: #969696 !important;
}
/* 有 scoped 情况 */
/deep/ .el-table,
/deep/ .el-table__header tr,
/deep/ .el-table__header th,
/deep/ .el-table__body tr,
/deep/ .el-table__body td {
  border-color: #969696 !important; /* 修改这里为你想要的颜色 */
}

/* 表头底部单独边框（可选微调） */
/deep/ .el-table__header th {
  border-bottom-color: #969696 !important;
}
</style>